import styled, { keyframes, css } from 'styled-components'

import { Text } from '../texts'

const MENU_ITEM_SIZING = {
  m: { height: 40, padding: 15 },
  mm: { height: 50, padding: 20 },
  l: { height: 60, padding: 20 },
}

function setSvgColor(color) {
  return css`
    fill: ${color};
    color: ${color};
  `;
}

const Item = styled.div`
  position: relative;
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${p => MENU_ITEM_SIZING[p.size].height}px;
  cursor: ${p => p.disabled ? 'auto' : 'pointer'};
  pointer-events: ${p => p.disabled ? 'none' : 'auto'};

  :not(:first-child) {
    border-width: 0;
    border-top-color: ${p => p.theme.color.background};
    border-style: solid;
    border-top-width: ${p => p.withBorder ? 1 : 0}px;
  }

  &:hover {
    background-color: ${p => p.theme.color.pale};
    border-radius: 15px;
    ${Text} {
      color: ${p => p.theme.color[p.disabled ? 'disabled' : 'turquoise']};
    }

    svg {
      ${p => setSvgColor(p.theme.color[p.disabled ? 'disabled' : 'turquoise'])}
    }
  }

  svg {
    height: 20px;
    ${p => setSvgColor(p.disabled
      ? p.theme.color.disabled
      :  p.iconColor
          ? p.iconColor
          : p.theme.color.gray)}
    margin-right: ${p => MENU_ITEM_SIZING[p.size].padding}px;
  }

  ${Text}, svg {
    transition: ${p => p.theme.duration.s} ${p => p.theme.function.oq};
  }

  img {
    height: 30px;
    width: 30px;
    margin-right: 20px;
  }
`

const IconWithText = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
`

const SubText = styled.span`
  margin-left: auto;
  margin-right: 20px;
`

const TooltipContainer = styled.div`
  z-index: 1;
  position: relative;
  height: 15px;
  display: flex;

  svg {
    height: 15px;
  }
`

const DropdownAppearAnimation = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`

const Dropdown = styled.div`
  width: ${p => p.width || 180}px;
  box-shadow: ${p => p.theme.shadow.m};
  border-radius: 15px;
  background-color: ${p => p.theme.color.backgroundRush};
  transform-origin: ${p => (p.emergencePlace ? p.emergencePlace : 'left top')};
  animation: ${DropdownAppearAnimation} ${p => p.theme.duration.s} ${p => p.theme.function.oq};
  z-index: 10;
`

export const Styled = {
  Item,
  IconWithText,
  SubText,
  TooltipContainer,
  Dropdown,
}


